module.exports = __webpack_public_path__ + "img/civilwar.b341bb83.svg";